export const allActivities = "allActivities";
export const approveVaultUser = 'approveVaultUser';
export const claimRewards = "claimRewards";
export const seasonThree = "seasonThree";
export const discordDetails = "discordDetails";
export const uniV2StakeEpoch = "uniV2StakeEpoch";
export const pointsVaultApprovedUsers = 'pointsVaultApprovedUsers';
export const pointsVaultPendingUsers = 'pointsVaultPendingUsers';
export const pointsVaultRejectedUsers = 'pointsVaultRejectedUsers';
export const pointsVaultSearch = 'pointsVaultSearch';
export const pointsVaultUserLoginKey = 'pointsVaultUserLogin';
export const pushPreviousStakeEpoch = "pushPreviousStakeEpoch";
export const pushStakeEpoch = "pushStakeEpoch";
export const rejectVaultUser = 'rejectVaultUser';
export const rewardActivityStatus = "rewardActivityStatus";
export const rewardsActivity = "rewardsActivity";
export const rewardsLeaderboardS1 = "rewardsLeaderboardS1";
export const rewardsLeaderboardS2 = "rewardsLeaderboardS2";
export const userRewardsDetails = "userRewardsDetails";
export const userRewardsStats = 'userRewardsStats';
export const userTwitterDetails = 'userTwitterDetails';
export const seasonOneUserDetails = "seasonOneUserDetails";

export const characterEligible = "characterEligible";
export const characterInfo = "characterInfo";
export const characterGenerate = "characterGenerate";
export const characterMint = "characterMint";
export const characterReshuffle = "characterReshuffle";
export const eligibleForPreLaunch = "eligibleForPreLaunch";
export const seasonThreeUserByWallet = "seasonThreeUserByWallet";
export const advancedSybilCheck = "advancedSybilCheck";
export const rewardsLeaderboardS3 = "rewardsLeaderboardS3";
export const squadsDetails = "squadsDetails";
export const createSquad = "createSquad";
export const sendSquadInvite = "sendSquadInvite";
export const acceptSquadInvite = "acceptSquadInvite";
export const rejectSquadInvite = "rejectSquadInvite";
export const squadsLeaderboard = "squadsLeaderboard";
export const spinStatus = "spinStatus";
export const spinTheWheel = "spinTheWheel";
export const getAllInvites = "getAllInvites";
export const requestInviteCode = "requestInviteCode";
export const resolveInviteLink = "resolveInviteLink";
export const createNewSeasonThreeUser = "createNewSeasonThreeUser";
export const getDailyCheckInDetails = "getDailyCheckInDetails";
export const claimDailyRewardsNewSeasonThree = "claimDailyRewardsNewSeasonThree";
export const squadsPendingInvites = "squadsPendingInvites";
export const resolveWallet = "resolveWallet";
export const levelProgress = "levelProgress";
export const quests = "quests";
export const questsProgress = "questsProgress";
export const rarePassHistory = "rarePassHistory";
export const pushWalletSybilCheck = "pushWalletSybilCheck";
export const nextReshuffleFee = "nextReshuffleFee";
export const userCultStatus = "userCultStatus";
export const cultLeaderboard = "cultLeaderboard";
export const sybilStatus = "sybilStatus";
export const verifySybilWallet = "verifySybilWallet";
export const pcTokenBalance = "pcTokenBalance";
export const userLevelConfig = "userLevelConfig";
export const questActivities = "questActivities";
